import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CourierCompanyModalService {

  private selectedCourierCompanySubject = new BehaviorSubject<any>(null);
  public selectedCourierCompany$ = this.selectedCourierCompanySubject.asObservable();

  constructor() { }

  setSelectedCourierCompany(courierCompany: any): void {
    this.selectedCourierCompanySubject.next(courierCompany);
  }

  getSelectedCourierCompany(): any | null {
    return this.selectedCourierCompanySubject.value;
  }

  clearSelectedCourierCompany(): void {
    this.selectedCourierCompanySubject.next(null);
  }
}
